import { FORM_BUILDER_FIELD_TYPE, ButtonSizeOptions } from "@loanbossinc/component-library";

import { isCustom, isAuto } from "./projections-variables-rows-logic";

const getChartData = data => {
  const propertyProjections = data && data.propertyProjections ? data.propertyProjections : [];
  rows.chart.cells[0].chartData = propertyProjections;
  rows.chart.cells[0].period = data.periodTypeAssumption;
};

export const rows = {
  title: {
    label: "Projection Variables"
  },
  chart: {
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.CHART,
        getData: getChartData,
        chartData: [],
        label: "Property Projections",
        height: "240",
        width: "575",
        keys: ["NOI Actual", "NOI Lender"],
        axisBottomLegend: "Years",
        axisLeftLegend: "",
        indexBy: "periodDate",
        enableLabel: false,
        numeralPattern: "$0,0",
        legendParams: [{
          "dataFrom": "keys",
          "anchor": "top-left",
          "direction": "column",
          "justify": true,
          "translateX": 10,
          "translateY": -50,
          "itemsSpacing": 0,
          "itemWidth": 100,
          "itemHeight": 20,
          "itemDirection": "left-to-right",
          "itemOpacity": 0.85,
          "symbolSize": 14,
          "effects": [{
            "on": "hover",
            "style": { "itemOpacity": 1 }
          }]
        }]
      }
    ]
  },
  projectionType: {
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TOGGLE,
        externalLabel: "Projection Type",
        options: [{ name: "Custom", index: 0 }, { name: "Auto", index: 1 }],
        name: "isAutoProjectionCalculationIndex",
        handleChange: (value, formik) => {
          const isAutoProjectionCalculation = value && value.index === 1;
          const values = formik.values;
          values.isAutoProjectionCalculationIndex = !value ? 1 : value.index;
          values.isAutoProjectionCalculation = isAutoProjectionCalculation;
          formik.handleChange();
          formik.handleBlur();
        },
        style: { "float": "right" }
      }
    ]
  },

  // custom
  asOfDate: {
    isVisible: data => isCustom(data),
    label: "As Of Date",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DATE,
        name: "asOfDate",
        variant: "filled"
      }
    ]
  },
  periodType: {
    isVisible: data => isCustom(data),
    label: "Period Type / Term",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "periodType",
        name: "periodType",
        variant: "filled",
        label: "Period Type",
        hideLabel: true,
        options: [
          { name: "Annual", id: 12 },
          { name: "Quarterly", id: 3 },
          { name: "Monthly", id: 1 }
        ],
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: () => { }
      }, {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "termInPeriod",
        variant: "filled",
        hideLabel: true,
        label: "Term"
      }
    ]
  },
  download: {
    isVisible: data => isCustom(data),
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.BUTTON,
        externalLabel: "Download a template generated by the values above.",
        size: ButtonSizeOptions.sm,
        label: "Download",
        hideLabel: true,
        onClick: () => { },
        style: { "float": "right" }
      }
    ]
  },
  fileUpload: {
    isVisible: data => isCustom(data),
    label: "UPLOAD TEMPLATE",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TEXT,
        value: "",
        style: {
          display: "block",
          fontWeight: "500",
          fontSize: "16px",
          lineHeight: "19px"
        }
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.TEXT,
        value: "Upload the template after filling out your projections",
        style: {
          display: "block",
          fontFamily: "Work Sans",
          fontStyle: "normal",
          fontWeight: "normal",
          fontSize: "16px",
          lineHeight: "19px"
        }
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.FILE_LOADER,
        multiple: false,
        onDrop: () => { }
      }
    ]
  },

  // auto
  term: {
    isVisible: data => isAuto(data),
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        label: "Term (Months)",
        name: "termAssumption",
        variant: "filled"
      }
    ]
  },
  capRate: {
    isVisible: data => isAuto(data),
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.PERCENT,
        label: "Cap Rate",
        name: "capRateAssumption",
        decimals: 2,
        variant: "filled",
        labelStyle: { marginTop: "16px" }
      }
    ]
  },
  noiActualBumpAssumption: {
    isVisible: data => isAuto(data),
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.PERCENT,
        label: "Annual NOI Increase",
        name: "noiActualBumpAssumption",
        decimals: 2,
        variant: "filled"
      }
    ]
  },
  occupancyAssumption: {
    isVisible: data => isAuto(data),
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.PERCENT,
        label: "Occupancy",
        name: "occupancyAssumption",
        decimals: 2,
        variant: "filled",
        labelStyle: { marginTop: "16px" }
      }
    ]
  },
  update: {
    isVisible: data => isAuto(data),
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.BUTTON_PRIMARY,
        externalLabel: "",
        size: ButtonSizeOptions.sm,
        label: "Update",
        hideLabel: true,
        onClick: (_, formik) => {
          formik.handleSubmit();
        },
        style: { "float": "right", marginLeft: "24px" }
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.BUTTON,
        size: ButtonSizeOptions.sm,
        label: "Reset",
        hideLabel: true,
        onClick: (_, formik) => {
          formik.handleReset();
        },
        style: { "float": "right" }
      }
    ]
  }
};
